import {useTranslation} from "react-i18next";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useReducer} from "react";
import {getDirectionDataAPI, saveTechnicalInfoAPI} from "../../../../../../../../services/api/projectCurrent";
import DarkCard from "../../../../../../../../components/card/DarkCard";
import LordIcon from "../../../../../../../../components/ui/LordIcon";
import {Colors} from "../../../../../../../../components/theme";
import {find_cooperationsWith, find_solistes, INITIAL_POPUP, INITIAL_STATE, techInfoReducer} from "./techInfoReducer";
import PopupWithContext from "../../../../../../../../components/ui/Popup/PopupWithContext";
import Select from "react-select";
import select_styles from "../../../../../../../../layouts/elements";
import CooperationWith from "./CooperationWith";
import {RemoveIcon} from "../../../../../../../../components/ui/RemoveIcon";
import CooperationPopupForm from "./CooperationPopupForm";
import { TxtTitles } from "../../../../../../../../helpers/breadCrumbs";
import LightCard from "../../../../../../../../components/card/LightCard";
import RedHeader from "../../../../../../../../components/ui/RedBgTitleHeader";
import Solistes from "./Solistes";
import DirectSolistPopupForm from "./DirectSolistPopupForm";
import {Input, InputWrapperDiv} from "../../../../../../../../components/ui/Input";
import {Button} from "../../../../../../../../components/ui/Button";
import SavingPopupContext from "../../../../../../../../components/ui/Popup/SavingPopupContext";
import OkBtnPopupContext from "../../../../../../../../components/ui/Popup/OkBtnPopupContext";
import {isObjectEmpty} from "../../../../../../../../helpers/tools";


export default function TechInfoEdit() {
    const [state, dispatch] = useReducer(techInfoReducer, INITIAL_STATE, undefined)
    const {t} = useTranslation()
    const params = useParams()
    const navigate = useNavigate();
    const location = useLocation()
    const global_return_path = () => navigate("/projects/current/"+params.id)

    useEffect(() => {
        const get_data_set_api = async () => {
            // try {
                const response = await getDirectionDataAPI(params.id)
                const data_set = response.data
                await dispatch({
                    type: "INITIAL_DATA",
                    projectName: location.state ? location.state.datasetName : "",
                    returnPatch: sessionStorage.getItem('project-current-return'),
                    direction: data_set.direction,
                    directionsList: data_set.directionsList,
                    concertmastersList: data_set.concertmastersList,
                    concertmaster: data_set.concertmaster,
                    cooperationWith: data_set.cooperationWith,
                    cooperationsWithList: data_set.cooperationsWithList,
                    solistes: data_set.solistes,
                    solistesList: data_set.solistesList,
                    dressCode: data_set.dress_code,
                    projectProgram: data_set.projectProgram,
                    projectComment: data_set.projectComment,
                    aboutPupitre: data_set.aboutPupitre,
                })
            // } catch (ex) {
            //     console.error("Failed to download data set.");
            // }
        }
        get_data_set_api()
    }, [])

    useEffect(() => {
        return () => sessionStorage.removeItem('project-current-return')
    }, [location])

    const handlePopup = async (opt) => {
        if (state.popup.formName === "globalSave" && opt.type === 'save') {
            // zapis do bazy
            const stateCopy = structuredClone(state)
            delete stateCopy.popup
            delete stateCopy.returnPatch
            delete stateCopy.directionsList
            delete stateCopy.concertmastersList
            delete stateCopy.cooperationsWithList
            delete stateCopy.solistesList

            const response = await saveTechnicalInfoAPI(params.id, stateCopy)
            if (response && response.status === 200) {
                dispatch({
                    type: "SET_POPUP",
                    dataset: {
                        show: true,
                        variant: "editF",
                        title: t("OK"),
                        message: "Zaktualizowano wpisy w bazie.",
                        type: "formular",
                        okBtn: t("common.button.ok"),
                        formName: "OkBtn",
                    },
                    key: "popup"
                })
                return
            }
        }

        if (opt.type === 'save') {
            if (state.popup.formName === 'direction') {
                dispatch({
                    type: "SET_DIRECTION",
                    dataset: opt.newValue,
                })
            }
            if (state.popup.formName === 'cooperationWith') {
                if (opt.context_data.newValue === "") return
                dispatch({
                    type: "SET_COOPERATION_WITH",
                    dataset: opt.context_data.newValue,
                })
            }
            if (state.popup.formName === 'solistes') {
                if (opt.newValue.fullname === "" && opt.newValue.pk === 0) return
                dispatch({
                    type: "SET_SOLIST",
                    dataset: opt.newValue, // {fullname:'XXX/""", pk: X/0, comment: xxx/"")
                })
                }
            dispatch({type: "SET_POPUP", dataset: INITIAL_POPUP, key: "popup"})
        } else if (opt.type === 'cancel') {
            dispatch({type: "SET_POPUP", dataset: INITIAL_POPUP, key: "popup"})
            navigate(sessionStorage.getItem('project-current-return'))
        } else {
            dispatch({type: "SET_POPUP", dataset: INITIAL_POPUP, key: "popup"})
            global_return_path()
        }
    }

    const popupForm = {
        direction: <DirectSolistPopupForm
            handlePopup={handlePopup}
            dataList={state.directionsList}
            saveBtn={t(state.popup.leftBtn)}
            cancelBtn={t(state.popup.rightBtn)}
        />,
        cooperationWith: <CooperationPopupForm
            handlePopup={handlePopup}
            cooperationsWithList={state.cooperationsWithList.filter(el => el.pk !== find_cooperationsWith(el.pk, state.cooperationWith))}
            saveBtn={t(state.popup.leftBtn)}
            cancelBtn={t(state.popup.rightBtn)}
        />,
        solistes: <DirectSolistPopupForm
            handlePopup={handlePopup}
            dataList={state.solistesList.filter(el => el.value !== find_solistes(el.value, state.solistes))}
            saveBtn={t(state.popup.leftBtn)}
            cancelBtn={t(state.popup.rightBtn)}
        />,
        globalSave: <SavingPopupContext
            handlePopup={handlePopup}
            saveBtn={t(state.popup.leftBtn)}
            cancelBtn={t(state.popup.rightBtn)}
        />,
        OkBtn: <OkBtnPopupContext okBtn={t(state.popup.okBtn)} handlePopup={handlePopup} />,
    }

    return (<>
        {state.popup.show
            ? <PopupWithContext
                variant={state.popup.variant}
                title={t(state.popup.title)}
                message={t(state.popup.message)}
            >
                {popupForm[state.popup.formName]}
            </PopupWithContext>
        : <>
            <DarkCard classNames='mb-3 row'>
                <p className="m-0 p-0 breadcrumbs">
                    <span className="txt">{t("menu.projects",{ ns: 'menu' })}</span>&#8201;&#9656;&#8201;
                    <Link to={'/projects/currents-list'}>{t("menu.current_projects",{ ns: 'menu' })}</Link>&#8201;&#9656;&#8201;
                    <Link to={'/projects/current/'+params.id}>{t("breadcrumbs.project_title")} P{params.id}</Link>&#8201;&#9656;&#8201;
                    <span className="txt">{t("common.button.edit_techInfo")}</span>
                </p>
            </DarkCard>

            <DarkCard classNames='mb-3 row'>
                <TxtTitles>{t("project.project_name_title")}</TxtTitles>
                <h1 className='mb-3 mt-0 p-0' style={{marginTop: '-5px'}}>
                    {state.projectName}
                </h1>

                <LightCard>
                    <RedHeader title={t('project.techInfo_title')}/>
                    <div className="row mx-2 py-4" style={{borderBottom: `1px solid ${Colors.lightGray}`}}>
                        <div className="col-xs-6 col-sm-4">
                            {/*DIRECTION*/}
                            <TxtTitles>
                                {t("project.tech_info.direction_title")}
                            </TxtTitles>
                            {!isObjectEmpty(state.direction)
                                ? <div
                                    className='customSelectParent'
                                    style={{position: "relative"}}>
                                    {state.direction.first_name} {state.direction.last_name}
                                    <RemoveIcon
                                        className='fa fa-times'
                                        style={{
                                            position: 'relative',
                                            top: '0px',
                                            height: '20px',
                                            width: '20px',
                                            fontSize: '12px',
                                            padding: '3px 5px'
                                        }}
                                        onClick={() => dispatch({type: "REMOVE_DIRECTION"})}
                                    />
                                </div>
                                : <div className="py-2 ps-1">{t("common.titles.to_define")}</div>
                            }
                            {isObjectEmpty(state.direction) &&
                                <div className="mt-2">
                                    <Link className="addGroup" onClick={
                                        () => dispatch({type: "CREATE_POPUP_DIRECTION"})} to={""}>
                                        <LordIcon url='cross' color={`${Colors.red};`} rotate='45'
                                                    target='.addGroup'/>
                                        <span className="ps-2">{t("common.button.add")}</span>
                                    </Link>
                                </div>
                                }
                        </div>

                        <div className="col-xs-6 col-sm-4">
                            <TxtTitles>
                                {t("project.tech_info.in_coop_title")}
                            </TxtTitles>
                            <CooperationWith
                                dataset={state.cooperationWith}
                                dispatch={dispatch}
                            />

                        </div>
                        <div className="col-xs-6 col-sm-4">
                            <TxtTitles>
                                {t("project.tech_info.soloists_title")}
                            </TxtTitles>
                            <Solistes
                                dataset={state.solistes}
                                dispatch={dispatch}
                            />
                        </div>
                    </div>

                    <div className="row mx-2 py-4" style={{borderBottom: `1px solid ${Colors.lightGray}`}}>
                        <div className="col-xs-6 col-sm-4">
                            {/*KONCERTMASTER*/}
                            <TxtTitles>
                                {t("project.tech_info.kzm_title")}
                            </TxtTitles>
                            <Select
                                options={state.concertmastersList}
                                value={{value:state.concertmaster.pk, label: state.concertmaster.name}}
                                onChange={val => dispatch({
                                    type: "SET_CONCERTMASTER", dataset: val
                                })}
                                styles={select_styles}
                                isSearchable={true}
                                unstyled
                            />
                        </div>
                        <div className="col-xs-6 col-sm-4">
                            {/*DRESS_CODE*/}
                            <TxtTitles>
                                {t("project.tech_info.dreeCode_title")}
                            </TxtTitles>
                            <InputWrapperDiv>
                                <Input
                                    name='dress-code'
                                    value={state.dressCode}
                                    onChange={val => dispatch({
                                        type: "SET_DRESS_CODE",
                                        dataset: val,
                                        key: "dressCode"
                                    })}
                                    readOnly={true}
                                />
                            </InputWrapperDiv>

                        </div>
                        <div className="col-xs-6 col-sm-4">
                            {/*ABOUT PUPITRE*/}
                            <TxtTitles>
                                {t("project.tech_info.pupitre_title")}
                            </TxtTitles>
                            <InputWrapperDiv>
                                <Input
                                    name={"project-pupitre"}
                                    value={state.aboutPupitre}
                                    onChange={val => dispatch({
                                        type: "SET_ABOUTPUPITRE",
                                        dataset: val,
                                        key: "aboutPupitre"
                                    })}
                                    style={{width: "100%", fontSize: "19px"}}
                                    rows={3}
                                />
                            </InputWrapperDiv>
                        </div>
                    </div>

                    <div className="row mx-2 py-4">
                        <div className="col-xs-6 col-sm-4">
                            {/*PROGRAM*/}
                            <TxtTitles>
                                {t("project.tech_info.program_title")}
                            </TxtTitles>
                            <textarea
                                name={"project-program"}
                                value={state.projectProgram}
                                onChange={val => dispatch({
                                    type: "SET_PROJECT_PROGRAM",
                                    dataset: val.target.value,
                                    key: "projectProgram"
                                })}
                                style={{width: "100%", fontSize: "19px"}}
                                rows={10}
                            />
                        </div>
                        <div className="col-xs-6 col-sm-4">
                            {/*COMMENT*/}
                            <TxtTitles>
                                {t("project.tech_info.comment_title")}
                            </TxtTitles>
                            <textarea
                                name={"project-comment"}
                                value={state.projectComment}
                                onChange={val => dispatch({
                                    type: "SET_PROJECT_COMMENT",
                                    dataset: val.target.value,
                                    key: "projectComment"
                                })}
                                style={{width: "100%", fontSize: "19px"}}
                                rows={3}
                            />
                        </div>
                    </div>
                </LightCard>

                <div className="mt-3">
                    <Button
                        className='me-4'
                        variant='round'
                        style={{backgroundColor: `${Colors.green}`}}
                        name='save'
                        onClick={() => dispatch({type: "SAVE_TO_DB"})}>
                        {t("common.button.save")}
                    </Button>

                    <Button
                        className='me-4'
                        variant='round'
                        styling="bordered"
                        name='cancel'
                        onClick={() => global_return_path()}>
                        {t("common.button.cancel")}
                    </Button>
                </div>
            </DarkCard>
            </>}
    </>)
}